/* eslint-disable sonarjs/no-duplicate-string */
import useGetAccountManagement from '@modules/core/hooks/queries/useGetAccountManagement';
import { useGlobalStore } from '@modules/core/store';
import { identifyAmplitudeSession } from '@shared/analytics/amplitude';
import { ACCESS_TOKEN } from '@shared/const';
import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { datadogLogs } from '@datadog/browser-logs';
import useGetBrokerProfile from '@modules/core/hooks/queries/useGetBrokerProfile';
import { mapTokenToUser } from '@modules/identity/utils';

const usePersistUser = () => {
  const token = Cookies.get(ACCESS_TOKEN);
  const { data } = useGetAccountManagement();
  const {
    setUser, setCompany, user, company, isLoggedIn, setIsLoggedIn, setCanFetchFeatureConfiguration,
  } = useGlobalStore();
  const { data: brokerProfile } = useGetBrokerProfile(user?.id);

  useEffect(() => {
    if (token) {
      try {
        const tokenUserInfo = mapTokenToUser(token);
        setUser({
          ...brokerProfile,
          first_name: brokerProfile?.first_name ?? '',
          last_name: brokerProfile?.last_name ?? '',
          isGrantedAccessToMbPortal:
            brokerProfile?.is_granted_access_to_mb_portal,
          name: `${tokenUserInfo.firstName ?? ''} ${tokenUserInfo.lastName ?? ''}`,
          email: tokenUserInfo.email,
          id: tokenUserInfo.username,
          'custom:roles': tokenUserInfo.roles,
          brokerageId: brokerProfile?.brokerage_external_id,
          externalId: brokerProfile?.external_id,
        });
        datadogLogs.setUser({ id: tokenUserInfo.username });
        datadogLogs.setUserProperty('custom:roles', tokenUserInfo.roles);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Cannot decode token', { error });
      }
    }
  }, [brokerProfile, data?.first_name, data?.last_name, setUser, token]);

  useEffect(() => {
    if (!isLoggedIn) {
      const redirectUrl = window.location.origin;
      window.location.replace(
        `${IDENTITY_ROUTE}/auth/login-with-pwd?redirectUrl=${redirectUrl}/identity`
      );
    }
  }, [isLoggedIn]);

  useEffect(() => {
    setCompany({
      name: data?.company_name,
      id: data?.company_id!,
      logo: data?.company_logo,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    if (user && brokerProfile && company?.name) {
      identifyAmplitudeSession({
        name: `${brokerProfile.first_name ?? ''} ${brokerProfile.last_name ?? ''}`.trim(),
        email: user?.email,
        broker_id: user?.id,
        brokerage_id: brokerProfile.brokerage_external_id,
        brokerage_name: company.name,
      });
      setCanFetchFeatureConfiguration(true);
    }
  }, [user, company, brokerProfile, setCanFetchFeatureConfiguration]);

  return {
    user,
    company,
    setIsLoggedIn,
    accountData: data,
  };
};

export default usePersistUser;
